import { useMemo } from "react";
import { useSessions } from "../sessions/useSessions";
import { serverTime } from "./spaceTokens";

const time = (v) => serverTime(v)?.getTime() || 0;

/**
 * A space's sessions, sorted into what the space home shows.
 *
 * The server says what state each session is in (DRAFT, SCHEDULED, LIVE,
 * DONE — worked out from the schedule and the room, never stored), so
 * this only groups and orders:
 *
 *   now       the live session, or else the next scheduled one
 *   upcoming  scheduled, soonest first
 *   drafts    no date yet, newest first
 *   past      done, most recent first
 *
 * Everything else — loading, creating, editing — is useSessions'.
 */
export function useSpaceSessions(courseGuid) {
  const base = useSessions(courseGuid);
  const groups = useMemo(() => {
    const all = base.sessions || [];
    const live = all.filter((s) => s.state === "LIVE").sort((a, b) => time(b.started_at) - time(a.started_at));
    const upcoming = all
      .filter((s) => s.state === "SCHEDULED")
      .sort((a, b) => time(a.scheduled_at) - time(b.scheduled_at));
    const drafts = all.filter((s) => s.state === "DRAFT").sort((a, b) => time(b.created_date) - time(a.created_date));
    const past = all
      .filter((s) => s.state === "DONE")
      .sort((a, b) => time(b.ended_at || b.scheduled_at || b.started_at) - time(a.ended_at || a.scheduled_at || a.started_at));
    return { live, upcoming, drafts, past, now: live[0] || upcoming[0] || null };
  }, [base.sessions]);
  return { ...base, ...groups, isLoading: base.sessions === null };
}
